import { AuthController } from './auth.controller';
export * from './auth.controller';

export const CONTROLLERS = [
  AuthController
];
